import { Injectable } from '@angular/core';

/** Service que valida acessos e execuções de funcionalidades das análises de mercados das classificações */
@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoClassificacaoAuthGuardService {

    /** Verifica se pode criar um novo lançamento de classificação na análise de mercado */
    canCreateLancamento(idClienteAnaliseMercadoClassificacao: number, idCliente: number, ano: number, classificacoesSlug: number[]): boolean {
        // Se possuir o ID do lançamento da classificação na análise de mercado então não pode mais criar o lançamento
        if (idClienteAnaliseMercadoClassificacao) {
            return false;
        }
        // Se não possuir o cliente então não pode criar o lançamento
        if (!idCliente) {
            return false;
        }
        // Se não possuir o ano então não pode criar o lançamento
        if (!ano) {
            return false;
        }
        // Se não possuir o slug das classificações então não pode criar o lançamento da classificação
        if (!classificacoesSlug || classificacoesSlug.length === 0) {
            return false;
        }

        return true;
    }

    /** Verifica se pode abrir o lançamento da análise de mercado da classificação */
    canOpenLancamento(idClienteAnaliseMercadoClassificacao: number, idCliente: number, ano: number): boolean {
        // Se não possuir o ID do lançamento da classificação na análise de mercado então não abrir o lançamento
        if (!idClienteAnaliseMercadoClassificacao) {
            return false;
        }
        // Se não possuir o cliente então não pode abrir o lançamento
        if (!idCliente) {
            return false;
        }
        // Se não possuir o ano então não pode abrir o lançamento
        if (!ano) {
            return false;
        }

        return true
    }

    /** Verifica se pode excluir o lançamento da análise de mercado da classificação */
    canDeleteLancamento(idClienteAnaliseMercadoClassificacao: number): boolean {
        // Se não possuir o ID da análise de mercado da classificação, então não pode excluir
        if (!idClienteAnaliseMercadoClassificacao) {
            return false;
        }

        return true;
    }
}
